import { ROUTE_PATH_ADMIN_SETTINGS } from 'src/common/constants';

export const settingsPath = `${ROUTE_PATH_ADMIN_SETTINGS}?tab=email-settings`;
export const settingsQueryKey = 'cm-fetch-mailer-settings';
